import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=6494be1e&scoped=true&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494be1e",
  null
  
)

export default component.exports